import { usePageStore } from '@/store';
import * as TYPES from './_store/types';
const NBR_TYPE_NUM = {
    0: 'city',
    1: 'subdivision',
    2: 'community',
    3: 'area'
};
export async function asyncData(store) {
    const pageStore = usePageStore(this.$pinia)
    let nbrInfo = this.nbrInfo || {};
    const hjId = nbrInfo.hjId;
    const type = NBR_TYPE_NUM[nbrInfo.featureAreaType] || nbrInfo.type;

    let mlsArr = pageStore.page?.mlsOrgs || [];
    mlsArr = mlsArr.filter(item => item.id !== 22000);
    let params = {
        locType: type || '',
        locId: nbrInfo?.autoId || 0,
        locStr: nbrInfo?.label || '',
        mls: mlsArr.map(item => item.id).join(',')
    };
    if (pageStore.page && (pageStore.page['FEATURE_AREA_VERSION'] || pageStore.page.country === 'canada')) {
        params.useMlsCondition = true
    }
    let ps = [];
    if (type && hjId) {
        ps.push(store[TYPES.GET_GEOGRAPHIC]({ type, hjId, locType: type || '', locStr: nbrInfo?.label || '' }))
        ps.push(store[TYPES.GET_MARKETREPORT](params))   
    }
    if (this.theme === 'classic') {
        const agentId = (this.nbrInfo && this.nbrInfo.agentId) || 0;
        ps.push(pageStore.getAgentInfo(agentId));
        ps.push(store[TYPES.GET_FORMREQUIRED]())
    }
    return Promise.all(ps);
}